module.exports = __webpack_public_path__ + "img/biaogexiazai2.88580dbd.png";